// extracted by mini-css-extract-plugin
var _1 = "ucLpf";
export { _1 as "noAccessLabelDarkMode" }
